export default __webpack_public_path__ + "static/media/Snd_TryH.72a43e7d.mp3";